import { render, staticRenderFns } from "./HighlightProducts.vue?vue&type=template&id=74ce6c62&"
import script from "./HighlightProducts.vue?vue&type=script&lang=js&"
export * from "./HighlightProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports